module.exports = __webpack_public_path__ + "static/assets/227e111e87782d74ff4a12ce5342a492.svg";